import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from '@/pages/home/components/HeroSection';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import HotArticles from '@/pages/home/components/HotArticles';
import LatestPosts from '@/pages/home/components/LatestPosts';
import CommunityStats from '@/pages/home/components/CommunityStats';
import FAQSection from '@/pages/home/components/FAQSection';
import { siteInfo } from '@/mocks/clCommunityData';

const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteInfo.name,
  url: 'https://clshequ.com/',
  description: siteInfo.description,
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: siteInfo.name,
  url: 'https://clshequ.com/',
  description: siteInfo.description,
  foundingDate: '2018',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@clshequ.com',
    contactType: 'customer service',
  },
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(webSiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <HotArticles />
        <LatestPosts />
        <CommunityStats />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}